import { useClassName } from '@/styles/Accordion';
import { ComponentProps, StandaloneComponent } from '@/types/component';
import mergeProps from 'lib/utils/mergeProps';

export type AccordionToggleProps = ComponentProps<'div'>;

export const AccordionToggleComponent: StandaloneComponent<AccordionToggleProps> = ({ children, ...props }) => {
  const className = useClassName('toggle', props);

  return <div {...mergeProps({ className }, props)}>{children}</div>;
};
